import AdminPortal from "../admin/AdminPortal";
import {ContentPageInfo} from "./ContentPageInfo";


export interface IContentRendererAdminProps {
contentPage:string;
content:string;
    onUpdateContent:(content:string|null) => void;
}
const ContentRendererAdmin: React.FC<IContentRendererAdminProps> = (props) => {

    const { content, contentPage, onUpdateContent } = props;
    const pageToUse = (contentPage ?? "index") + ".jsx";
    return <AdminPortal>
        <h3>Content / { pageToUse }</h3>
            <form onSubmit={(ev) => {
                ev.preventDefault();
                onUpdateContent((ev.currentTarget.ownerDocument.getElementById("content") as HTMLTextAreaElement)!.value);
            }}>


        <textarea
            rows={50} cols={120} id={"content"}

        >{content}</textarea>
            <button type={"submit"}>Override</button>
        </form>
    </AdminPortal>
}

export default ContentRendererAdmin;